class AnnouncementBar {
  constructor(container) {
    this.container = container;
    if (!this.container) return;

    this.isMarquee = this.container.dataset.marquee === 'true';

    if (this.isMarquee) {
      this.initMarquee();
    } else {
      this.swiperContainer = this.container.querySelector('.announcement-bar__swiper');
      this.prevButton = this.container.querySelector('.announcement-bar__prev');
      this.nextButton = this.container.querySelector('.announcement-bar__next');

      const slides = this.container.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) {
        if (this.prevButton) this.prevButton.style.display = 'none';
        if (this.nextButton) this.nextButton.style.display = 'none';
      } else {
        this.initSwiper();
      }
    }

    this.updateAnnouncementHeight();
    window.addEventListener('resize', () => this.updateAnnouncementHeight());
  }

  initMarquee() {
    const marqueeContainer = this.container.querySelector('[data-marquee-container]');
    const track = this.container.querySelector('[data-marquee-track]');

    if (!marqueeContainer || !track) return;

    const trackWidth = track.offsetWidth;
    const containerWidth = marqueeContainer.offsetWidth;
    const clonesNeeded = Math.ceil((containerWidth * 2) / trackWidth) + 1;

    for (let i = 0; i < clonesNeeded; i++) {
      const clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-marquee-track');
      marqueeContainer.appendChild(clone);
    }

    const isMobile = window.innerWidth < 750;
    const speed = isMobile
      ? parseFloat(this.container.dataset.marqueeSpeedMobile) || 10
      : parseFloat(this.container.dataset.marqueeSpeedDesktop) || 15;

    marqueeContainer.style.setProperty('--marquee-duration', `${speed}s`);
    marqueeContainer.style.setProperty('--marquee-distance', `-${trackWidth}px`);
  }

  initSwiper() {
    const autoplay = this.container.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(this.container.dataset.autoplaySpeed) * 1000 || 5000;

    this.swiper = new Swiper(this.swiperContainer, {
      loop: true,
      autoplay: autoplay ? {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      navigation: {
        prevEl: this.prevButton,
        nextEl: this.nextButton
      }
    });
  }

  updateAnnouncementHeight() {
    const height = this.container.offsetHeight;
    const section = this.container.closest('.shopify-section');

    if (section) {
      section.style.setProperty('--announcement-height', `${height}px`);
    }
    document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-section-type="w-announcement-bar"]').forEach(container => {
    new AnnouncementBar(container);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const container = event.target.querySelector('[data-section-type="w-announcement-bar"]');
  if (container) {
    new AnnouncementBar(container);
  }
});
